export const openApiUrl = 'openapi.yaml';
